import { Switch, Route, Redirect } from 'react-router-dom'
import { CIMSModule, CIMSPage, pathify } from '@cims-online/shared'
import Developer from './components/Developer'
import Login from './components/Login'
import Home from '../Home'

/**
 * @see {@link Login} component for more information
 */
export const DevRoutes: React.FC = () => {
  const deprecated = CIMSPage.withDeprecatedPaths.flatMap((page) =>
    page.deprecatedProjectPaths.map((from) => {
      const to = from.includes(CIMSPage.deepLink)
        ? page.recordPath
        : page.projectPath
      return { from, to, key: `${from}->${to}` }
    })
  )

  return (
    <Switch>
      {deprecated.map(({ from, key, to }) => (
        <Redirect key={key} to={to} path={from} />
      ))}
      <Route exact path={'/'}>
        <Login />
      </Route>
      <Route
        path={[pathify(CIMSModule.Home.pathname), CIMSModule.Home.projectPath]}
      >
        <Home />
      </Route>
      <Route path={pathify(CIMSModule.Developer.pathname)}>
        <Developer />
      </Route>
    </Switch>
  )
}
